import { render, staticRenderFns } from "./deleteReport.vue?vue&type=template&id=164a4dd4&scoped=true&"
import script from "./deleteReport.vue?vue&type=script&lang=js&"
export * from "./deleteReport.vue?vue&type=script&lang=js&"
import style0 from "./deleteReport.vue?vue&type=style&index=0&id=164a4dd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a4dd4",
  null
  
)

export default component.exports